import React, { useState } from 'react';
import './Gallery.css';
import { galleryImages } from '../data';

function Gallery() {
  const [filter, setFilter] = useState('all');
  const [lb, setLb] = useState(null);

  /* ── LOGIC UNTOUCHED ── */
  const visible = filter === 'all' ? galleryImages : galleryImages.filter(i => i.category === filter);

  return (
    <section id="gallery" className="gallery section">
      <div className="container">

        <span className="section-label">Our Work</span>
        <h2 className="section-heading">A Feast for <em>the Eyes</em></h2>
        <p className="section-desc">
          Real food from real events — scroll through our delicious portfolio of authentic Chettinad spreads.
        </p>

        {/* ── Filter buttons — logic untouched ── */}
        <div className="gal-filters">
          {['all', 'food', 'events'].map(f => (
            <button
              key={f}
              className={`gal-btn ${filter === f ? 'on' : ''}`}
              onClick={() => setFilter(f)}
            >
              {f.charAt(0).toUpperCase() + f.slice(1)}
            </button>
          ))}
        </div>

        {/* ── Masonry grid ── */}
        <div className="gal-masonry">
          {visible.map((img, idx) => (
            <div
              key={img.id}
              className={`gal-item gal-item--${idx % 5 === 0 ? 'tall' : idx % 3 === 0 ? 'wide' : 'normal'}`}
              onClick={() => setLb(img)}
            >
              {img.src
                ? <img src={img.src} alt={img.label} />
                : (
                  <div className="gal-ph">
                    <span>📷</span>
                    <p>{img.label}</p>
                    <small>img{img.id}.jpg</small>
                  </div>
                )
              }
              <div className="gal-overlay">
                <span className="gal-overlay__cat">{img.category}</span>
                <span className="gal-overlay__label">{img.label}</span>
              </div>
            </div>
          ))}
        </div>

      </div>

      {/* ── Lightbox — logic untouched ── */}
      {lb && (
        <div className="lb" onClick={() => setLb(null)}>
          <button className="lb-x" onClick={() => setLb(null)}>✕</button>
          <div className="lb-inner" onClick={e => e.stopPropagation()}>
            {lb.src
              ? <img src={lb.src} alt={lb.label} />
              : (
                <div className="lb-ph">
                  <span>📷</span>
                  <p>{lb.label}</p>
                </div>
              )
            }
            <p className="lb-label">{lb.label}</p>
          </div>
        </div>
      )}
    </section>
  );
}

export default Gallery;